// const baseURL = "https://stagingapi.myclnqhealth.com/"; //Stging
const baseURL = "https://myclnqapi.ssivixlab.com/"; //Production

const config = {
  baseURL,
};

export default config;
